export const getModalWidth = (
  minWidth: number,
  maxWidth: number,
  screenWidth: number,
  largeScreenBreakpointPx: number
): number => {
  if (screenWidth >= largeScreenBreakpointPx) {
    return maxWidth;
  }
  if (screenWidth >= maxWidth) {
    return maxWidth;
  }
  if (screenWidth >= minWidth) {
    return screenWidth;
  }
  return minWidth;
};

/**
 *
 * Calculates the correct value for a dimension depending on if it's in content or default
 *
 * @param modalWidth
 * @param baseValue
 * @param modalReferenceDimension
 * @param value
 */
export const getScaledValueForWidth = (
  modalWidth: number,
  baseValue: number,
  modalReferenceDimension: number,
  value?: number
): number => {
  return (modalWidth * (value || baseValue)) / modalReferenceDimension;
};
